import {ENDPOINT_RULES} from 'common/endpoints';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import {commonJwtHeader} from 'common/utils';

const getRulesByPayload = (token, body) => {
  return fetch(`${ENDPOINT_RULES}`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const getIneligibleItems = (token, grantId, fundingOpportunityId) => {
  let encodedRules = encodeURI(
    `[{"configType": "fo", "configId": "${fundingOpportunityId}", "ruleSet":"eligibility"}]`
  );
  return fetch(`${ENDPOINT_RULES}?grantId=${grantId}&rules=${encodedRules}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRulesByRuleSet = (token, grantId, fundingOpportunityId, ruleSet) => {
  let encodedRules = encodeURI(
    `[{"configType": "fo", "configId": "${fundingOpportunityId}", "ruleSet": "${ruleSet}"}]`
  );

  return fetch(`${ENDPOINT_RULES}?grantId=${grantId}&rules=${encodedRules}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getIneligibleItems,
  getRulesByRuleSet,
  getRulesByPayload,
};
